// iOS auto-zooms inputs unless every viewport meta carries maximum-scale=1
// (pinch zoom stays available on iOS 10+). Easify injects its own meta around
// window load, and a tap always precedes a focus — so three one-shot passes
// cover every meta with no ongoing observers.
export default function iosViewportFix() {
    if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) return;

    const fixViewportMetas = () => {
        document.head.querySelectorAll('meta[name="viewport"]').forEach((meta) => {
            const content = meta.getAttribute('content') || '';
            if (!content.includes('maximum-scale')) {
                meta.setAttribute('content', `${content.trim()},maximum-scale=1`);
            }
        });
    };

    fixViewportMetas();
    window.addEventListener('load', fixViewportMetas, { once: true });
    document.addEventListener('touchstart', fixViewportMetas, { once: true, capture: true, passive: true });
}
